module.exports = __webpack_public_path__ + "static/media/diaper80-100.c003871f.png";